import type { FaireProductEntity } from "../../entity_types/product";

export const p_vgea2xr296: FaireProductEntity = {
  token: "p_vgea2xr296",
  type: "product",
  name: "Helium 80 Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/51349b55f31791b55bd038f21fd3bf7bce0db92998b679237f463e0c44a0cd56.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d24d3c4582bf977ce1ad40b89df2427628e438c8ba839039c1f68979fa0bdca.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:10.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
